import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, FormHelperText } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1, 0),
  },
}));

const MyFormControl = (props) => {
  const {
    children,
    error,
    fullWidth,
    helperText,
    required,
  } = props;
  const classes = useStyles();

  return (
    <FormControl
      required={required}
      className={classes.formControl}
      error={error}
      fullWidth={fullWidth}
    >
      {children}
      {
        error
          ? (
            <FormHelperText>
              <FormattedMessage id={helperText} />
            </FormHelperText>
          ) : <span />
      }
    </FormControl>
  );
};

MyFormControl.propTypes = {
  children: PropTypes.node.isRequired,

  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
};

MyFormControl.defaultProps = {
  error: false,
  fullWidth: false,
  helperText: '',
  required: false,
};

export default MyFormControl;
